import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { ICustomConfigurationRepository } from '../../repositories/interfaces/iCustomConfigurationRepository';
import { IProfileAvatarsResponse } from '../../../entity/interface/iProfile';

export interface IProfileAvatarsUseCase {
    execute(): Promise<IProfileAvatarsResponse>;
}

export class GetProfileAvatarUseCase implements IProfileAvatarsUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get customConfigurationRepository(): ICustomConfigurationRepository {
        return container.resolve<ICustomConfigurationRepository>(DI.REPOSITORIES.ICustomConfigurationRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(): Promise<IProfileAvatarsResponse> {
        const response = await this.customConfigurationRepository.getProfileAvatars();
        return response;
    }
}
